import { useTranslation } from 'react-i18next';

const useButtonTranslations = () => {
  const { t } = useTranslation();

  const button = (translationKey: string) => t(`buttons.${translationKey}`);

  // const keys = [
  //   'back',
  //   'confirm',
  //   'close',
  //   'cancel',
  //   'continue',
  //   'ok',
  //   'acceptQuote',
  //   'rejectQuote',
  //   'payNow',
  //   'yes',
  //   'no',
  // ];
  //
  // const translations: { [key: string]: string } = {};
  //
  // keys.forEach((key) => {
  //   translations[key] = button(key);
  // });

  //return translations;

  return {
    back: button('back'),
    backToDashboard: button('backToDashboard'),
    confirm: button('confirm'),
    close: button('close'),
    cancel: button('cancel'),
    continue: button('continue'),
    done: button('done'),
    ok: button('ok'),
    acceptQuote: button('acceptQuote'),
    rejectQuote: button('rejectQuote'),
    payNow: button('payNow'),
    yes: button('yes'),
    no: button('no'),
    tryAgain: button('tryAgain'),
    button,
  };
}

export default  useButtonTranslations;